<template>
    <section class="p-3" id="new-physician-form">
        <section class="form-group">
            <h6>Search Physician</h6>
            <div class="d-flex align-items-center justify-content-center pb-2 w-50 m-auto">
                <label id="New_Physician_Npi_Search" for="New_Physician_Npi_Search">NPI Number: </label>
                <TypeaheadInput
                    :getData="getNpi"
                    v-on:valueChanged="updateAllFields"
                    :results-limit="1"
                    maxlength="10"
                    placeholder=""
                />
            </div>
        </section>
        <section class="form-group">
            <h6>Physician Information</h6>
            <div class="d-grid px-4 py-2">
                <div class="d-flex flex-column">
                    <div class="d-grid mb-2">
                        <label for="New_Physician_First_Name">First Name: <span class="text-danger">*</span></label>
                        <div>
                            <input
                                type="text"
                                :class="`form-control ${!v$.newPhysician.FirstName.$error ? '' : 'field-invalid'}`"
                                id="New_Physician_First_Name"
                                maxlength="50"
                                name="FirstName"
                                v-model="newPhysician.FirstName"
                                @blur="v$.newPhysician.FirstName.$touch"
                            />
                            <span v-if="v$.newPhysician.FirstName.$error" class="field-invalid"
                                >First Name is required.</span
                            >
                        </div>
                    </div>

                    <div class="d-grid mb-2">
                        <label for="New_Physician_Middle_Intial">MI:</label>
                        <input
                            class="form-control"
                            id="New_Physician_Middle_Intial"
                            maxlength="1"
                            name="MiddleName"
                            type="text"
                            v-model="newPhysician.MiddleName"
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_Last_Name">Last Name:<span class="text-danger">*</span></label>
                        <div>
                            <input
                                :class="`form-control ${!v$.newPhysician.LastName.$error ? '' : 'field-invalid'}`"
                                id="New_Physician_Last_Name"
                                maxlength="50"
                                name="LastName"
                                type="text"
                                v-model="newPhysician.LastName"
                                @blur="v$.newPhysician.LastName.$touch"
                            />
                            <span v-if="v$.newPhysician.LastName.$error" class="field-invalid"
                                >Last Name is required.</span
                            >
                        </div>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_Taxonomy_Code">Taxonomy Code:</label>
                        <input
                            class="form-control"
                            id="New_Physician_Taxonomy_Code"
                            maxlength="11"
                            name="TaxonomyCode"
                            type="text"
                            v-model="newPhysician.TaxonomyCode"
                        />
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <div class="d-grid mb-2">
                        <label for="New_Physician_Credentials">Credentials:</label>
                        <input
                            class="form-control"
                            id="New_Physician_Credentials"
                            maxlength="40"
                            name="Credentials"
                            type="text"
                            v-model="newPhysician.Credentials"
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_Npi_Number">NPI No:<span class="text-danger">*</span></label>
                        <div>
                            <input
                                :class="`form-control ${!v$.newPhysician.NPI.$error ? '' : 'field-invalid'}`"
                                id="New_Physician_Npi_Number"
                                maxlength="10"
                                name="NPI"
                                type="text"
                                v-model="newPhysician.NPI"
                                v-on:blur="checkPecos"
                                @blur="v$.newPhysician.NPI.$touch"
                            />
                            <span v-if="v$.newPhysician.NPI.$error" class="field-invalid">NPI is required.</span>
                        </div>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_Pecos_Check">PECOS Verification:</label>
                        <div id="New_Physician_Pecos_Check" v-html="isPecosVerified"></div>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_Tpi_Number">Medicaid Provider Identifier:</label>
                        <input
                            class="form-control"
                            id="New_Physician_Tpi_Number"
                            maxlength="10"
                            name="TPI"
                            type="text"
                            v-model="newPhysician.TPI"
                        />
                    </div>
                </div>
            </div>
        </section>
        <section class="form-group">
            <h6>Physician Address</h6>
            <div class="d-grid px-4 py-2">
                <div class="d-flex flex-column">
                    <div class="d-grid mb-2">
                        <label for="New_Physician_AddressLine1"
                            >Address Line 1: <span class="text-danger">*</span></label
                        >
                        <div>
                            <input
                                :class="`form-control ${!v$.newPhysician.AddressLine1.$error ? '' : 'field-invalid'}`"
                                id="New_Physician_AddressLine1"
                                maxlength="75"
                                name="AddressLine1"
                                type="text"
                                v-model="newPhysician.AddressLine1"
                                @blur="v$.newPhysician.AddressLine1.$touch"
                            />
                            <span v-if="v$.newPhysician.AddressLine1.$error" class="field-invalid"
                                >Address is required.</span
                            >
                        </div>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_AddressLine2">Address Line 2:</label>
                        <input
                            class="form-control"
                            id="New_Physician_AddressLine2"
                            maxlength="75"
                            name="AddressLine2"
                            type="text"
                            v-model="newPhysician.AddressLine2"
                        />
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_AddressCity">City: <span class="text-danger">*</span></label>
                        <div>
                            <input
                                :class="`form-control ${!v$.newPhysician.AddressCity.$error ? '' : 'field-invalid'}`"
                                id="New_Physician_AddressCity"
                                maxlength="75"
                                name="AddressCity"
                                type="text"
                                v-model="newPhysician.AddressCity"
                                @blur="v$.newPhysician.AddressCity.$touch"
                            />
                            <span v-if="v$.newPhysician.AddressCity.$error" class="field-invalid"
                                >City is required.</span
                            >
                        </div>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_AddressStateCode">State:</label>
                        <select
                            class="form-select"
                            id="New_Physician_AddressStateCode"
                            name="AddressStateCode"
                            v-model="newPhysician.AddressStateCode"
                        >
                            <option :value="null">-- Select State --</option>
                            <option
                                v-for="item in referralOptions.addressStateCode"
                                :key="item.value"
                                :value="item.value"
                            >
                                {{ item.text }}
                            </option>
                        </select>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_AddressZip">Zip:<span class="text-danger">*</span></label>
                        <div>
                            <input
                                :class="`form-control ${!v$.newPhysician.AddressZipCode.$error ? '' : 'field-invalid'}`"
                                id="New_Physician_AddressZipCode"
                                maxlength="13"
                                name="AddressZipCode"
                                type="text"
                                v-model="newPhysician.AddressZipCode"
                                v-on:blur="updateZipAddress"
                                @blur="v$.newPhysician.AddressZipCode.$touch"
                            />
                            <span v-if="v$.newPhysician.AddressZipCode.$error" class="field-invalid"
                                >Zip is required.</span
                            >
                        </div>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_Phone">Primary Phone:<span class="text-danger">*</span></label>
                        <div>
                            <input
                                type="text"
                                :class="`form-control ${!v$.newPhysician.PhoneWork.$error ? '' : 'field-invalid'}`"
                                name="PhoneWorkArray"
                                id="New_Physician_Phone"
                                maxlength="10"
                                v-model="newPhysician.PhoneWork"
                                @blur="v$.newPhysician.PhoneWork.$touch"
                            />
                            <span v-if="v$.newPhysician.PhoneWork.$error" class="field-invalid"
                                >Primary Phone is required.</span
                            >
                        </div>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_AltPhone">Alternate Phone:</label>
                        <input
                            type="text"
                            class="form-control"
                            name="PhoneAltArray"
                            id="New_Physician_AltPhone"
                            maxlength="10"
                            v-model="newPhysician.PhoneAlternate"
                        />
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <div class="d-grid mb-2">
                        <label for="New_Physician_Delivery_Method"
                            >Order Delivery Method:<span class="text-danger">*</span></label
                        >
                        <div>
                            <select
                                :class="`form-select ${!v$.newPhysician.DeliveryType.$error ? '' : 'field-invalid'}`"
                                id="New_Physician_Delivery_Method"
                                name="DeliveryType"
                                v-model="newPhysician.DeliveryType"
                                @blur="v$.newPhysician.DeliveryType.$touch"
                            >
                                <option value="null">-- Delivery Method --</option>
                                <option value="1">Axxess Physician Portal</option>
                                <option value="2">Fax</option>
                                <option value="3">Mail</option>
                                <option value="4">Courier</option>
                                <option value="5">Electronic</option>
                                <option value="6">Other</option>
                            </select>

                            <span v-if="v$.newPhysician.DeliveryType.$error" class="field-invalid"
                                >Delivery Method is required.</span
                            >
                        </div>
                    </div>
                    <div
                        class="d-grid mb-2"
                        id="Physician_ElectronicDeliveryType"
                        v-if="newPhysician.DeliveryType == 5"
                    >
                        <label for="New_Physician_ElectronicDeliveryType"
                            >Vendor:<span class="text-danger">*</span></label
                        >

                        <div>
                            <select
                                :class="`form-select ${
                                    !v$.newPhysician.ElectronicDeliveryType.$error ? '' : 'field-invalid'
                                }`"
                                id="New_Physician_ElectronicDeliveryType"
                                name="ElectronicDeliveryType"
                                v-model="newPhysician.ElectronicDeliveryType"
                                @blur="v$.newPhysician.ElectronicDeliveryType.$touch"
                            >
                                <option :value="null">--Select Vendor--</option>
                                <option value="3">WorldView</option>
                            </select>
                            <span v-if="v$.newPhysician.ElectronicDeliveryType.$error" class="field-invalid"
                                >Vendor is required.</span
                            >
                        </div>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_Fax"
                            >Fax:<span class="text-danger" v-if="newPhysician.DeliveryType == 2">*</span></label
                        >
                        <div>
                            <input
                                type="text"
                                :class="`form-control ${!v$.newPhysician.FaxNumber.$error ? '' : 'field-invalid'}`"
                                name="FaxNumberArray"
                                id="New_Physician_Fax"
                                maxlength="10"
                                v-model="newPhysician.FaxNumber"
                                @blur="v$.newPhysician.FaxNumber.$touch"
                            />
                            <span v-if="v$.newPhysician.FaxNumber.$error" class="field-invalid"
                                >Fax Number is required.</span
                            >
                        </div>
                    </div>
                    <div class="d-grid mb-2">
                        <label for="New_Physician_Email"
                            >E-mail:<span class="text-danger" v-if="newPhysician.DeliveryType == 1">*</span></label
                        >
                        <div>
                            <input
                                :class="`form-control ${!v$.newPhysician.EmailAddress.$error ? '' : 'field-invalid'}`"
                                id="New_Physician_Email"
                                maxlength="100"
                                name="EmailAddress"
                                type="text"
                                v-model="newPhysician.EmailAddress"
                                @blur="v$.newPhysician.EmailAddress.$touch"
                            />
                            <span v-if="v$.newPhysician.EmailAddress.$error" class="field-invalid"
                                >Email is required.</span
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div class="d-flex justify-content-center">
            <button class="btn btn-primary me-2 border-0" @click="addNewPhysician()">Save</button>
            <button class="btn btn-outline-primary" @click="closeDialog()">Cancel</button>
        </div>
    </section>
</template>

<style lang="scss">
.d-grid {
    display: grid;
    grid-template-columns: 2fr 3fr;
    gap: 1rem;
}

#new-physician-form {
    .form-group {
        box-shadow: 0px 0px 12px 0 rgba(163, 163, 163, 0.37);
        border-radius: 5px;
        padding: 10px;
    }
}
</style>
<script lang="ts" src="./NewPhysicianHH.ts"></script>
